module.exports = __webpack_public_path__ + "img/model_56.13b67fdf.jpg";